import { DateTime } from "luxon";

export const setToday = () => {
  return new Date().toLocaleDateString("fr-CA");
};

export const setPeriod = () => {
  return new Date().toISOString().substring(0, 7);
};

export const setYear = () => {
  return new Date().getFullYear();
};

export const getYearsArray = () => {
  let now = new Date().getFullYear();
  let max = now + 100;
  let min = 1900;
  let years = [];
  for (let i = max; i >= min; i--) {
    years.push(`${i}`);
  }
  return years;
};

function fillFormatDateOptions(params) {
  let options = { year: "numeric", month: "2-digit", day: "2-digit" };
  if (params) {
    options = Object.assign(options, params);
  }
  return options;
}

export const systemFormatDate = (date) => {
  if (date != undefined && date != null && date != "" && date != "Invalid date") return DateTime.fromISO(date).toFormat("dd/MM/yyyy");
  return null;
};

export const formatDate = function formatDate(date, params) {
  if (date != null && date != "") {
    return new Date(date).toLocaleString("es-MX", fillFormatDateOptions(params));
  }
  return "";
};

export const formatDateTime = function formatDateTime(date, params) {
  if (date != null && date != "") {
    let options = { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" };
    if (params) {
      options = Object.assign(options, params);
    }
    return new Date(date).toLocaleString("es-MX", options);
  }
  return "";
};

export const formatPeriod = function formatPeriod(period) {
  return `${period}`.replaceAll(/(\d{4})(\d{2})/g, "$1-$2");
};

export const getDateFromLocalToUTC = (date) => {
  if (date != undefined && date != null && date != "" && date != "Invalid date") {
    return DateTime.fromISO(date).toFormat("yyyy-MM-dd");
  }
  return "";
};

export const formatToISO = (str) => {
  if (str && str.length == 10) {
    const [day, month, year] = str.split("-").map((value) => value.trim());
    return `${day}-${month}-${year}`;
  }
  return "";
};

export const getTodayMinusDays = (days) => {
  const now = DateTime.now();
  const daysAgo = now.minus({ days: days });
  return daysAgo.toISODate();
};



// WEBPACK FOOTER //
// ./src/helpers/date-methods.js